import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { filter, map, switchMap, tap } from 'rxjs'
import { RegistrationData, RegistrationPractitionerUserMetadata } from '../types'
import { isNotNull } from './filter'
import { registrationRequest } from './signup'
import { setRegistrationSuccess } from './success'

const [practitionerRegistrationInput$, setPractitionerRegistrationInput] = createSignal<{
  input: RegistrationData & RegistrationPractitionerUserMetadata
}>()

// create hook for sharing latest input pending subscription to request observable
const [useLatestPractitionerRegistrationInput, latestPractitionerRegistrationInput$] = bind(
  practitionerRegistrationInput$,
  null
)

export { setPractitionerRegistrationInput, useLatestPractitionerRegistrationInput }

export const practitionerRegistrationRequest$ = latestPractitionerRegistrationInput$.pipe(
  filter(isNotNull),
  switchMap(({ input }) =>
    registrationRequest({ input, isGuestCheckoutEnabled: false }).pipe(
      map((response) => ({ input, response })),
      tap(setRegistrationSuccess)
    )
  )
)
